var account = "帳戶";
var accountSettings = "帳戶設定";
var charging = "充電";
var contactInfo = "聯絡資料";
var dashboard = "帳戶主頁";
var home = "主頁";
var myProducts = "我的產品";
var orderHistory = "訂購記錄";
var paymentMethod = "付款方式";
var profileSettings = "帳戶設定";
var referAndEarn = "推薦並賺取積分";
var signOut = "登出";
var zh_HK = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, zh_HK as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
